import { useLocation } from 'react-router-dom';
import { OnscreenApi } from '..//../pages';

export const OnscreenApiWrapper = () => {
  const location = useLocation();

  return <OnscreenApi key={location.key} />;
};
